import { createSelector } from '@reduxjs/toolkit';

import { URL_PATH } from 'constants/index';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.erpSystem || initialState;
const createBasename = (state: RootState) => {
  return `/${state.erpSystem?.language}/${URL_PATH}`;
};

export const selectBasenamePath = createSelector(
  [createBasename],
  state => state,
);

export const selectErpSystemState = createSelector(
  [selectSlice],
  state => state,
);
export const selectErpSystem = createSelector(
  [selectSlice],
  state => state.erpSystem,
);
export const selectLanguageId = createSelector(
  [selectSlice],
  state => state.languageId,
);
export const selectLanguage = createSelector(
  [selectSlice],
  state => state.language,
);
